import React, { useState } from "react";
import "./whychose.css";

const peopleServed = [
  {
    icon: "👨‍🎓",
    title: "Freshers: Looking to Start Their Career Journey",
    content: [
      "Access to entry-level positions in top-tier companies",
      "Resume preparation and interview coaching",
      "Guidance on technical and soft skill development",
      "Opportunities to build your profile through internships or job-based training",
    ],
    footer:
      "Our goal is to ensure you don’t just land your first job — you launch a long-term career with confidence and clarity.",
  },
  {
    icon: "👩‍💼",
    title: "Experienced Professionals: Seeking Growth or a New Direction",
    content: [
      "Curated openings in Level 1 to Level 5 companies",
      "Support for domain changes or promotions",
      "Help with negotiating better roles or packages",
      "Connections to companies with strong growth cultures and tech-driven environments",
    ],
    footer:
      "We work discreetly and strategically to ensure your next move is a step forward, not just a step away.",
  },
  {
    icon: "🔄",
    title: "Career Changers: Transitioning into IT or ITES Roles",
    content: [
      "Upskilling guidance to build the right technical foundation",
      "Career counseling tailo#ffb703 to your background and goals",
      "Openings that value transferable skills like communication, analytics, and project management",
      "Mentoring and roadmaps to help you bridge the gap between your past experience and future potential",
    ],
    footer:
      "With the right guidance, your industry switch becomes a strategic step into a rewarding IT/ITES career.",
  },
];


function Whychose() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="whychose-section">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Content Section */}
          <div className="col-lg-12 content-container">
            <div className="content-wrapper">
              <div className="section-header">
                <div className="section-title clearfix">
                  <div className="title-header">
                    <h5 style={{ textTransform: "uppercase", color: "#ffb703" }}>
                      WHO WE SERVE
                    </h5>
                    <h3>OUR OFFERINGS</h3>
                  </div>
                  <div className="underline"></div>
                </div>
                <p>
                  Our talent network spans across India and beyond, connecting candidates to global opportunities.
                  We actively engage with companies in multiple international markets to broaden your career prospects.
                </p>
                <div className="container why-container ">


                  <div className="col-lg-4 tab-menu">
                    {peopleServed.map((item, index) => (
                      <div
                        key={index}
                        className={`tab-item ${activeIndex === index ? "active" : ""}`}
                        onClick={() => setActiveIndex(index)}
                      >
                        <span className="tab-icon">{item.icon}</span>
                        <span className="tab-text">{item.title}</span>
                      </div>
                    ))}
                  </div>

                  <div className="col-lg-8 tab-content-box fade-in">
                    <h3 className="tab-title">{peopleServed[activeIndex].title}</h3>
                    <ul>
                      {peopleServed[activeIndex].content.map((point, i) => (
                        <li key={i}>{point}</li>
                      ))}
                    </ul>
                    <p className="tab-footer">{peopleServed[activeIndex].footer}</p>
                  </div>
                </div>
               


              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Whychose;
